module.exports = __webpack_public_path__ + "assets/img/costs_all_img.71237a35.png";